import React from 'react'
import { useMediaQuery } from '@hooks'
import { sizes } from '@theme'
import { StyledFullGridItem3x3 } from '../../List/style'
import Card, { AddressCard } from '../../Card'
import { generateRandomKey, shortenTitle } from '@utils'
import Box from '@components/Box'

const GridRow = ({
  numItems,
  items,
  borderLeft,
  rowHeights,
  contentfulType,
  gridType = '3x3',
  gridLines = true,
  cardType = 'default',
  padding,
}) => {
  const xs = useMediaQuery(`(max-width: ${sizes.xsmall.max})`)
  const sm = useMediaQuery(`(max-width: ${sizes.small.max})`)
  const md = useMediaQuery(`(max-width: ${sizes.medium.max})`)
  const lg = useMediaQuery(`(max-width: ${sizes.large.max})`)
  const rowHeight =
    rowHeights &&
    ((xs && rowHeights.xs) ||
      (sm && rowHeights.sm) ||
      (md && rowHeights.md) ||
      (lg && rowHeights.lg) ||
      rowHeights.xl)

  const height = (rowHeight && `${rowHeight}px`) || '100%'

  const sizes4x4 = {
    xs: 12,
    sm: 6,
    md: 4,
    lg: 3,
    xl: 3,
  }

  const sizes3x3 = {
    xs: 12,
    sm: 6,
    md: 6,
    lg: 4,
    xl: 4,
  }

  const sizes2x2 = {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6,
  }

  const gridSizesMap = {
    '2x2': sizes2x2,
    '3x3': sizes3x3,
    '4x4': sizes4x4,
  }

  // const GridItem = gridType === '2x2' ? StyledFullGridItem : StyledFullGridItem3x3
  const GridItem = StyledFullGridItem3x3
  const gridSizes = gridSizesMap[gridType]

  const borderTop = gridLines && numItems <= 3 ? '1px solid #DDE0E3' : 'none'
  const border = !gridLines ? 'none' : null

  const CardComponent = item => {
    if (contentfulType !== 'ContentfulArticle') {
      contentfulType =
        item.__typename === 'ContentfulAccolade'
          ? 'ContentfulAccolade'
          : item.eventStart
          ? 'ContentfulEvent'
          : 'ContentfulNews'
    }
    const tag =
      contentfulType === 'ContentfulArticle' ? item?.category?.title : null
    const title =
      item?.title?.length > 105 ? shortenTitle(item.title) : item.title
    switch (cardType) {
      case 'office':
        return <AddressCard office={item} directions />
      default:
        return (
          <Card
            tag={tag}
            title={title}
            item={item}
            id={item.id}
            key={generateRandomKey()}
            to={item?.slug}
            slugContentType={contentfulType}
            slugCategory={item?.category?.slug}
            style={{ height: rowHeight }}
          />
        )
    }
  }
  return (
    <Box height={height} width="100%" borderLeft={borderLeft} display="flex">
      {items.map(item => (
        <GridItem
          key={generateRandomKey()}
          border={gridLines}
          xs={gridSizes.xs}
          sm={gridSizes.sm}
          md={gridSizes.md}
          lg={gridSizes.lg}
          xl={gridSizes.xl}
          style={{ border, borderTop, padding }}
        >
          {CardComponent(item)}
        </GridItem>
      ))}
    </Box>
  )
}

export default GridRow
